export default () => {
  const timeline = document.querySelector('.ecodigo-timeline');
  const timelineList = timeline?.querySelector('.ecodigo-timeline__list');
  const timelineItems = timelineList?.querySelectorAll('.ecodigo-timeline__list__item');

  if (timelineItems && timelineItems.length) {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        threshold: 1, // 100%
      },
    );
    timelineItems.forEach((item) => {
      observer.observe(item);
    });
  }
};
